"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkillSuggestionWidget = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _card = require("@design/ui/card");
var _closeButton = require("@design/ui/close-button");
var _field = require("@design/ui/field");
var _input = require("@design/ui/input");
var _textarea = require("@design/ui/textarea");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SkillSuggestionWidgetComponent = function SkillSuggestionWidgetComponent(_ref) {
  var data = _ref.data,
    onSave = _ref.onSave,
    onDismiss = _ref.onDismiss,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Save as skill?" : _ref$title,
    _ref$saveLabel = _ref.saveLabel,
    saveLabel = _ref$saveLabel === void 0 ? "Save Skill" : _ref$saveLabel,
    _ref$dismissLabel = _ref.dismissLabel,
    dismissLabel = _ref$dismissLabel === void 0 ? "Dismiss" : _ref$dismissLabel;
  var fieldIdPrefix = (0, _react.useId)();
  var _useState = (0, _react.useState)(data.name),
    _useState2 = _slicedToArray(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = (0, _react.useState)(data.description),
    _useState4 = _slicedToArray(_useState3, 2),
    description = _useState4[0],
    setDescription = _useState4[1];
  var _useState5 = (0, _react.useState)(data.content),
    _useState6 = _slicedToArray(_useState5, 2),
    content = _useState6[0],
    setContent = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSaving = _useState8[0],
    setIsSaving = _useState8[1];
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setIsSaving(true);
            _context.p = 1;
            _context.n = 2;
            return onSave(name.trim(), description.trim(), content.trim());
          case 2:
            _context.p = 2;
            setIsSaving(false);
            return _context.f(2);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[1,, 2, 3]]);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  var primaryDisabled = !name.trim() || !content.trim() || isSaving;
  var secondaryDisabled = isSaving;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    className: "my-1.5",
    "data-sentry-element": "Card",
    "data-sentry-component": "SkillSuggestionWidgetComponent",
    "data-sentry-source-file": "SkillSuggestionWidget.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardHeader, {
      "data-sentry-element": "CardHeader",
      "data-sentry-source-file": "SkillSuggestionWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardTitle, {
        className: "flex items-center gap-1 text-foreground-muted",
        "data-sentry-element": "CardTitle",
        "data-sentry-source-file": "SkillSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SparklesIcon, {
          "data-sentry-element": "SparklesIcon",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx"
        }), title]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardAction, {
        "data-sentry-element": "CardAction",
        "data-sentry-source-file": "SkillSuggestionWidget.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
          "aria-label": "Dismiss skill suggestion",
          disabled: isSaving,
          onClick: function onClick() {
            return onDismiss();
          },
          size: "icon-xs",
          "data-sentry-element": "CloseButton",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "SkillSuggestionWidget.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.FieldGroup, {
        "data-sentry-element": "FieldGroup",
        "data-sentry-source-file": "SkillSuggestionWidget.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          "data-sentry-element": "Field",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            htmlFor: "".concat(fieldIdPrefix, "-name"),
            "data-sentry-element": "FieldLabel",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx",
            children: "Name"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, {
            id: "".concat(fieldIdPrefix, "-name"),
            value: name,
            onChange: function onChange(e) {
              return setName(e.target.value);
            },
            placeholder: "Enter a name for this skill",
            "data-sentry-element": "Input",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          "data-sentry-element": "Field",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            htmlFor: "".concat(fieldIdPrefix, "-description"),
            "data-sentry-element": "FieldLabel",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx",
            children: "Description"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
            id: "".concat(fieldIdPrefix, "-description"),
            value: description,
            onChange: function onChange(e) {
              return setDescription(e.target.value);
            },
            placeholder: "Describe what this skill does and when to use it",
            "data-sentry-element": "Textarea",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
          "data-sentry-element": "Field",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
            htmlFor: "".concat(fieldIdPrefix, "-content"),
            "data-sentry-element": "FieldLabel",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx",
            children: "Skill Prompt"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
            id: "".concat(fieldIdPrefix, "-content"),
            className: "max-h-36",
            value: content,
            onChange: function onChange(e) {
              return setContent(e.target.value);
            },
            placeholder: "The full instructions for this skill",
            "data-sentry-element": "Textarea",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex justify-end gap-2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
          type: "button",
          variant: "outline",
          size: "xs",
          onClick: onDismiss,
          disabled: secondaryDisabled,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx",
          children: dismissLabel
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
          type: "button",
          size: "xs",
          onClick: handleSave,
          disabled: primaryDisabled,
          "data-sentry-element": "Button",
          "data-sentry-source-file": "SkillSuggestionWidget.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SaveIcon, {
            "data-icon": "inline-start",
            "data-sentry-element": "SaveIcon",
            "data-sentry-source-file": "SkillSuggestionWidget.tsx"
          }), isSaving ? "Saving..." : saveLabel]
        })]
      })]
    })]
  });
};
var SkillSuggestionWidget = exports.SkillSuggestionWidget = /*#__PURE__*/_react.default.memo(SkillSuggestionWidgetComponent);